import React from "react";
import useGeneralStore from "@/store/General/useGeneralStore";
import { parseJsonBody } from "@/lib/general.utils";

const SocialLinks: React.FC<{ color?: string }> = ({ color }) => {
  const { SocialLinksComponent } = useGeneralStore((state) => ({
    SocialLinksComponent: state.SocialLinksComponent,
  }));

  if (!SocialLinksComponent || SocialLinksComponent.length === 0) {
    return null;
  }

  // Map platform names to icon paths
  const getIconPath = (platform: string) => {
    const iconMap: Record<string, string> = {
      facebook: "/icons/facebook.png",
      instagram: "/icons/instagram.png",
      twitter: "/icons/twitter.png",
      linkedin: "/icons/linkedin.png",
      youtube: "/icons/youtube.png",
      snapchat: "/icons/snapchat.png",
      whatsapp: "/icons/whatsapp.png",
    };
    return iconMap[platform.toLowerCase()] || null;
  };

  return (
    <div className="h-auto flex items-center gap-[0.5rem]">
      {SocialLinksComponent.map((component) => {
        const jsonBody = parseJsonBody(component.jsonBody);
        const platform = jsonBody?.platform || "";
        const url = jsonBody?.url || "";
        const imageUrl = jsonBody?.imageUrl || "";
        const iconPath = getIconPath(platform);

        if (!url) return null;

        return (
          <a
            key={component.id}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className={`p-[0.2rem] rounded-lg flex items-center justify-center transition-all duration-500 hover:opacity-65 ${
              color ? `text-${color}` : ""
            }`}
          >
            {imageUrl ? (
              <img
                src={imageUrl}
                alt={platform}
                className="w-[1.8rem] h-[1.8rem] object-cover rounded-full filter brightness-100 invert"
              />
            ) : iconPath ? (
              <img
                src={iconPath}
                alt={platform}
                className={`w-[1.8rem] filter brightness-100 invert`}
              />
            ) : null}
          </a>
        );
      })}
    </div>
  );
};

export default SocialLinks;
